var chunkMapping = {
	"1697": [
		1697
	],
	"2115": [
		2115
	],
	"3070": [
		3070
	],
	"3250": [
		3250
	],
	"3369": [
		3369
	],
	"3488": [
		3488
	],
	"4127": [
		4127
	],
	"4623": [
		7004
	],
	"5197": [
		5197
	],
	"5212": [
		5212
	],
	"5271": [
		5271
	],
	"5711": [
		5711
	],
	"5887": [
		5887
	],
	"6172": [
		6172
	],
	"6482": [
		330,
		421,
		5534,
		6435
	],
	"6921": [
		6921
	],
	"7343": [
		9724
	],
	"7657": [
		7657
	],
	"8307": [
		8307
	],
	"8855": [
		8855
	],
	"9166": [
		9166
	]
};
var idToExternalAndNameMapping = {
	"330": [
		"default",
		"./generic/components/general/toast",
		1005
	],
	"421": [
		"default",
		"./generic/helpers/google-tag-manager",
		1005
	],
	"1697": [
		"default",
		"./generic/elements/form",
		1005
	],
	"2115": [
		"default",
		"./generic/components/general/button-group",
		1005
	],
	"3070": [
		"default",
		"./generic/components/general/sheet",
		1005
	],
	"3250": [
		"default",
		"./ecom/components/order-summary",
		1005
	],
	"3369": [
		"default",
		"./generic/components/general/rich-text",
		1005
	],
	"3488": [
		"default",
		"./generic/components/general/modal",
		1005
	],
	"4127": [
		"default",
		"./generic/elements/cms-picture",
		1005
	],
	"5197": [
		"default",
		"./generic/components/general/component-simple-header",
		1005
	],
	"5212": [
		"default",
		"./generic/elements/badge",
		1005
	],
	"5271": [
		"default",
		"./generic/elements/icons",
		1005
	],
	"5534": [
		"default",
		"./generic/elements/menu-item",
		1005
	],
	"5711": [
		"default",
		"./generic/elements/info-block",
		1005
	],
	"5887": [
		"default",
		"./generic/components/profile/avatar-upload",
		1005
	],
	"6172": [
		"default",
		"./generic/components/cards/card-clubs",
		1005
	],
	"6435": [
		"default",
		"./generic/components/profile/avatar",
		1005
	],
	"6921": [
		"default",
		"./generic/elements/loading",
		1005
	],
	"7004": [
		"default",
		"./generic/components/navigation/breadcrumbs",
		1005
	],
	"7657": [
		"default",
		"./generic/components/cards/card-category",
		1005
	],
	"8307": [
		"default",
		"./ecom/components/product-summary",
		1005
	],
	"8855": [
		"default",
		"./generic/elements/accordion",
		1005
	],
	"9166": [
		"default",
		"./generic/elements/divider",
		1005
	],
	"9724": [
		"default",
		"./generic/elements/button",
		1005
	]
};
var idToRemoteMap = {
	"330": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"421": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"1697": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"2115": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"3070": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"3250": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"3369": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"3488": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"4127": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5197": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5212": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5271": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5534": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5711": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5887": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"6172": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"6435": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"6921": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"7004": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"7657": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"8307": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"8855": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"9166": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"9724": [
		{
			"externalType": "script",
			"name": "core"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"330": {
		"shareScope": "default",
		"name": "./generic/components/general/toast",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"421": {
		"shareScope": "default",
		"name": "./generic/helpers/google-tag-manager",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"1697": {
		"shareScope": "default",
		"name": "./generic/elements/form",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"2115": {
		"shareScope": "default",
		"name": "./generic/components/general/button-group",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"3070": {
		"shareScope": "default",
		"name": "./generic/components/general/sheet",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"3250": {
		"shareScope": "default",
		"name": "./ecom/components/order-summary",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"3369": {
		"shareScope": "default",
		"name": "./generic/components/general/rich-text",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"3488": {
		"shareScope": "default",
		"name": "./generic/components/general/modal",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"4127": {
		"shareScope": "default",
		"name": "./generic/elements/cms-picture",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"5197": {
		"shareScope": "default",
		"name": "./generic/components/general/component-simple-header",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"5212": {
		"shareScope": "default",
		"name": "./generic/elements/badge",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"5271": {
		"shareScope": "default",
		"name": "./generic/elements/icons",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"5534": {
		"shareScope": "default",
		"name": "./generic/elements/menu-item",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"5711": {
		"shareScope": "default",
		"name": "./generic/elements/info-block",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"5887": {
		"shareScope": "default",
		"name": "./generic/components/profile/avatar-upload",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"6172": {
		"shareScope": "default",
		"name": "./generic/components/cards/card-clubs",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"6435": {
		"shareScope": "default",
		"name": "./generic/components/profile/avatar",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"6921": {
		"shareScope": "default",
		"name": "./generic/elements/loading",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"7004": {
		"shareScope": "default",
		"name": "./generic/components/navigation/breadcrumbs",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"7657": {
		"shareScope": "default",
		"name": "./generic/components/cards/card-category",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"8307": {
		"shareScope": "default",
		"name": "./ecom/components/product-summary",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"8855": {
		"shareScope": "default",
		"name": "./generic/elements/accordion",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"9166": {
		"shareScope": "default",
		"name": "./generic/elements/divider",
		"externalModuleId": 1005,
		"remoteName": "core"
	},
	"9724": {
		"shareScope": "default",
		"name": "./generic/elements/button",
		"externalModuleId": 1005,
		"remoteName": "core"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}